

































































import {Component, Prop, Vue} from 'vue-property-decorator';
import JdiContent from "@/components/JdiContent.vue"
import JdiPreview from "@/components/JdiPreview.vue"
import JdiDocs from "@/components/JdiDocs.vue"
import JdhStructuralButton from "@/design-system/shared/structural/JdhStructuralButton.vue"
import JdhInlineLoader from "@/design-system/shared/JdhInlineLoader.vue"

@Component({
    components: {JdhInlineLoader, JdhStructuralButton, JdiDocs, JdiPreview, JdiContent}
})
export default class StructuralButton extends Vue {
}
